module.exports = __webpack_public_path__ + "img/lanscape-2.dc20ec34.webp";